<template>
  <div class="full-screen-diagnosis" @click="closeSelector">
    <popup ref="disgnosisiPopup" full-screen :visible="true" :show-choose="false">
      <div class="full-screen-diagnosis-charts">
        <div class="hor-operation-area">
          <div class="hor-operation-area__left">
            <div ref="selector" class="chart-selector" @click.stop="toggleSelector">
              <span class="chart-selector__label">{{ currentSelectorLabel }}</span>
              <i
                :class="[
                  'chart-selector__icon',
                  'icon-outlinedpickup',
                  { 'chart-selector__icon--expanded': selectorVisible },
                ]"
              />
              <transition name="selector-dropdown-fade">
                <div v-if="selectorVisible" class="chart-selector__dropdown" @click.stop>
                  <div
                    v-for="item in selectorOptions"
                    :key="item.value"
                    class="chart-selector__option"
                    @click="submitSelector(item.value)"
                  >
                    <span>{{ item.label }}</span>
                  </div>
                </div>
              </transition>
            </div>
            <div class="close-btn" @click="hide">
              <i class="crm-Icon-claim-vist" />
            </div>
          </div>
        </div>
        <div v-if="isFormulaPage" class="formula-fullscreen-page">
          <FormulaHorizontalHeader
            :cards="formulaCards"
            :selected-index="innerFormulaSelectedIndex"
            @select="selectFormulaCard"
          />
          <ModesChart
            v-if="formulaChartOptions.length"
            ref="formulaChart"
            :options="formulaChartOptions"
            :height="formulaChartHeight"
            chartkey="conversionFormula"
            direction="horizontal"
            :show-fullscreen-button="false"
            :legend-selected-map="formulaLegendSelectedMap"
          />
          <DiagnosisLegendBR
            v-if="formulaLegendItems.length"
            :items="formulaLegendItems"
            :active="formulaLegendActive"
            direction="horizontal"
            :show-collapse="false"
            :style="{ paddingLeft: `${formulaLegendLeftPadding}px` }"
            @toggle="handleFormulaLegendToggle"
          />
        </div>
        <DiagnosisItemBR
          v-else
          :data="horChartData"
          :direction="direction"
          :show-compare-info="showCompareInfo"
          :advertise-item="advertiseItem"
        />
      </div>
    </popup>
  </div>
</template>
<script>
import Popup from '@/components/Popup'
import DiagnosisItemBR from '../DiagnosisItemBR/index.vue'
import ModesChart from '../DiagnosisItemBR/ModesChart/index.vue'
import DiagnosisLegendBR from '../DiagnosisItemBR/Legend/index.vue'
import FormulaHorizontalHeader from '../OrderConversionSection/FormulaHorizontalHeader.vue'
import { buildFormulaChartOption } from '../../utils/formulaChartBuilder.js'
import { getEchartHeightAndBottomByLocale } from '../../utils/builderBR.js'

const { heightHor: formulaChartHeight } = getEchartHeightAndBottomByLocale('usersAndConversion')

export default {
  name: 'FullHorShowChartBR',
  components: {
    Popup,
    DiagnosisItemBR,
    ModesChart,
    DiagnosisLegendBR,
    FormulaHorizontalHeader,
  },
  props: {
    showCompareInfo: {
      type: Boolean,
      default: false,
    },
    chartIndex: {
      type: Number,
      default: 0,
    },
    diagnosisData: {
      type: Array,
      default: () => {
        return []
      },
    },
    direction: {
      type: String,
      default: 'vertical',
    },
    advertiseItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectorVisible: false,
      innerFormulaSelectedIndex: 0,
      formulaLegendActive: [true, true],
      formulaChartHeight,
    }
  },
  computed: {
    fullScreenOptions() {
      const options = [
        { label: this.$t('FoodB_APP_sdNU_DaTX' /** 投资&营销 */), value: 0 },
        { label: this.$t('FoodB_2_wbni_uePM' /** 服务 */), value: 1 },
        { label: this.$t('FoodB_202402_RxAj_UFpT' /** 用户 */), value: 2 },
      ]
      if (this.diagnosisData[3]) {
        options.push({ label: this.$t('FoodB_revamp_JrnZ_UzZC' /** 数据诊断公式 */), value: 3 })
      }
      return options
    },
    curIndex: {
      get() {
        return this.chartIndex
      },
      set(newValue) {
        this.$emit('click', newValue)
      },
    },
    title() {
      return this.horChartData && this.horChartData.title
    },
    selectorOptions() {
      return this.fullScreenOptions
    },
    currentSelectorLabel() {
      return this.selectorOptions.find(item => item.value === this.curIndex)?.label || ''
    },
    horChartData() {
      return this.diagnosisData[this.curIndex] || {}
    },
    isFormulaPage() {
      return this.horChartData.chartkey === 'conversionFormula'
    },
    formulaCards() {
      return this.horChartData.formulaCards || []
    },
    currentFormulaCard() {
      return this.formulaCards[this.innerFormulaSelectedIndex] || null
    },
    formulaLegendItems() {
      const card = this.currentFormulaCard
      if (!card || !card.chartData) return []
      const opt = buildFormulaChartOption(card.chartData, card.label, {
        embedded: false,
        metricKey: card.indicatorKey,
        direction: 'horizontal',
      })
      return opt.legendItems || []
    },
    formulaLegendSelectedMap() {
      return this.formulaLegendItems.reduce((result, item, index) => {
        result[item.name] = this.formulaLegendActive[index] !== false
        return result
      }, {})
    },
    formulaChartOptions() {
      const card = this.currentFormulaCard
      if (!card || !card.chartData) return []
      const opt = buildFormulaChartOption(card.chartData, card.label, {
        embedded: false,
        fullscreenComfort: true,
        metricKey: card.indicatorKey,
        direction: 'horizontal',
      })
      // 不再手动 filter series，交由 ModesChart 通过 legendSelectedMap 统一处理（保留 yAxis）
      return [
        {
          ...opt,
          legend: {
            ...(opt.legend || {}),
          },
          showCustomLegend: opt.showCustomLegend,
          legendItems: opt.legendItems,
        },
      ]
    },
    formulaLegendLeftPadding() {
      const opt = this.formulaChartOptions[0]
      return opt?.grid?.left || 0
    },
  },
  watch: {
    horChartData: {
      handler(data) {
        if (data?.chartkey === 'conversionFormula') {
          const nextIndex = Number(data.formulaSelectedIndex)
          this.innerFormulaSelectedIndex = Number.isFinite(nextIndex) ? nextIndex : 0
        }
      },
      immediate: true,
    },
    formulaLegendItems: {
      handler(items) {
        this.formulaLegendActive = (items || []).map(() => true)
      },
      immediate: true,
    },
  },
  methods: {
    toggleSelector() {
      this.selectorVisible = !this.selectorVisible
    },
    closeSelector() {
      this.selectorVisible = false
    },
    submitSelector(value) {
      this.selectorVisible = false
      if (value !== this.curIndex) {
        this.curIndex = value
      }
    },
    selectFormulaCard(index) {
      this.innerFormulaSelectedIndex = index
    },
    handleFormulaLegendToggle(payload) {
      this.handleLegendToggle(payload)
    },
    handleLegendToggle({ index }) {
      const next = [...this.formulaLegendActive]
      next[index] = !next[index]
      if (next.some(Boolean)) {
        this.formulaLegendActive = next
      }
    },
    show() {
      this.$refs.disgnosisiPopup.show()
    },
    hide() {
      this.selectorVisible = false
      this.$refs.disgnosisiPopup.hide()
    },
  },
}
</script>

<style lang="scss">
.hor-operation-area {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .hor-operation-area__left {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    z-index: 3;
  }

  .close-btn {
    width: 120px;
    height: 100px;
    display: flex;
    align-items: center;

    .crm-Icon-claim-vist {
      color: #000;
      font-size: 32px;
      margin-left: 48px;
    }
  }

  .chart-selector {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: fit-content;
    max-width: none;
    padding-left: 34px;
    height: 56px;
    border-radius: 28px;
    cursor: pointer;
    white-space: nowrap;
  }

  .chart-selector__label {
    font-family: 'DiDi Sans Pro';
    font-size: 36px;
    font-weight: 700;
    line-height: 32px;
    color: #0c0c0d;
    white-space: nowrap;
  }

  .chart-selector__icon {
    margin-left: 12px;
    font-size: 24px;
    color: #111111;
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  .chart-selector__icon--expanded {
    transform: rotate(180deg);
  }

  .chart-selector__dropdown {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    width: fit-content;
    min-width: 0;
    max-width: none;
    padding: 12px 0;
    background: #ffffff;
    border-radius: 24px;
    box-shadow: 0 12px 32px rgba(12, 12, 13, 0.16);
    overflow: hidden;
    white-space: nowrap;
  }

  .chart-selector__option {
    height: 72px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-family: 'DiDiSans-Pro-Medium';
    font-size: 24px;
    line-height: 32px;
    color: #0c0c0d;
    background: #ffffff;
    white-space: nowrap;

    &:active {
      background: #e3e3e5;
    }
  }

  .chart-name {
    flex: 1;
    min-width: 0;
    text-align: center;
    font-family: 'DiDiSans-Pro-Medium';
    font-size: 28px;
    line-height: 36px;
    color: #0c0c0d;
    padding-right: 48px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.formula-fullscreen-page {
  padding-right: 32px;
  padding-bottom: 134px;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

.selector-dropdown-fade-enter-active,
.selector-dropdown-fade-leave-active {
  transition: all 0.2s ease;
}

.selector-dropdown-fade-enter,
.selector-dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.full-screen-diagnosis {
  overflow: hidden;
  height: 100%;
  position: relative;
  .popup {
    .popup-panel {
      .popup-choose {
        display: none;
      }
    }
  }
}
.full-screen-diagnosis-charts {
  width: calc(100vh - var(--barheight));
  height: 100vw;
  transform: rotate(90deg);
  transform-origin: left top;
  margin-left: 100vw;
  padding-left: var(--barheight);
}
</style>
